import { render, staticRenderFns } from "./UmDbBoardList.vue?vue&type=template&id=3ee5aa12&"
import script from "./UmDbBoardList.vue?vue&type=script&lang=js&"
export * from "./UmDbBoardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports